import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitFilterValue } from "./pit-filter-value";
let PitFilteringAttribute = class PitFilteringAttribute {
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get values() {
        return this._values;
    }
    set values(value) {
        this._values = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilteringAttribute.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilteringAttribute.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitFilterValue, { name: "values", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitFilteringAttribute.prototype, "_values", void 0);
PitFilteringAttribute = tslib_1.__decorate([
    jsonObject
], PitFilteringAttribute);
export { PitFilteringAttribute };
